import React from 'react';
import './PinIcon.css';

function PinIcon({ filled, size, disabled }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="115 1018 20 20.3"
      className={`pin ${size} ${disabled ? 'disabled' : ''}`.trim()}
    >
      <g id="Group_1699" data-name="Group 1699" transform="translate(115 1018)">
        <path
          id="Path_4184"
          data-name="Path 4184"
          className={filled ? 'filled' : 'empty'}
          d="M25,23.6l-2,2,8.5,6.5Z"
          transform="translate(-11.5 -11.8)"
        />
        <path
          id="Path_4185"
          data-name="Path 4185"
          className={filled ? 'filled' : 'empty'}
          d="M3,2.8H3L5.85,0l3.9,5.55c5,.05,6.45,2.1,6.45,2.1L11.5,12.3l-4,4s-2-1.5-2-6.5L0,5.8Z"
        />
      </g>
    </svg>
  );
}

export default PinIcon;



// WEBPACK FOOTER //
// ./src/components/Icon/PinIcon/index.js